// extracted by mini-css-extract-plugin
export default {"render-value":"CheckPill_render-value__iZFet"};